import { Button, CircularProgress } from "@mui/material";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import avatarimage from '../../Assets/Images/avatar.jpg'
import person1 from '../../Assets/Images/image1.jpg'
import person2 from '../../Assets/Images/feedback-image-2.jpg'
import person3 from '../../Assets/Images/feedback-image-3.jpg'
import star from '../../Assets/Images/star.svg'
import Slider from 'react-slick';
import hideicon from "../../Assets/Images/hideicone.svg"
import showicon from "../../Assets/Images/showIcon.svg"
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../Context/AuthContext";
import Logo from '../../Assets/Images/logo.png'
import Stepper from "../../Components/Registration/Stepper";
import TPLogo from '../../Assets/Images/TPLogo.png';
import NewTPLogo from '../../Assets/Images/whiteLogo.png';
import { validateName } from '../../utils/helper';


const Signup = () => {

  useEffect(() => {
    localStorage.clear()
  }, [])


  const authCtx = useContext(AuthContext)
  
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [fullName, setFullName] = useState("");
  const navigate = useNavigate();
  const location = useLocation()
  const { id } = useParams();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const locationState = location?.state

  const formLink = () => {
    navigate("/first-form/" + id + "?" + searchParams, { replace: true });
  }
  const [activeSlide, setActiveSlide] = useState(0);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 15000,
    beforeChange: (current, next) => setActiveSlide(next),
    customPaging: (i) => {
      let dotSize = 8;
      if (i === activeSlide) {
        dotSize = 8;
      } else if (i === activeSlide - 1 || i === activeSlide + 1) {
        dotSize = 8;
      }
      return (
        <button
          style={{
            width: `${dotSize}px`,
            height: `${dotSize}px`,
            borderRadius: '50%',
            border: 'none'
          }}
        ></button>
      );
    }
  };

  const [hidetoggle, settoggle] = useState(true);
  const [chidetoggle, csettoggle] = useState(true);
  const [data, setData] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: '',
    fullNameError: '',
    emailError: '',
    passwordError: '',
    confirmPasswordError: '',
  });

  const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );
  const validNameRegex = /^[A-Za-z]+(?: [A-Za-z]+)+$/;
  ;

   let fromLoginPage;

  if ( locationState?.fromLoginPage ) {
    fromLoginPage = locationState?.fromLoginPage
  }

  console.log(fromLoginPage)


  const passwordShow = () => {
    settoggle(!hidetoggle);
  }

  const confpasswordShow = () => {
    csettoggle(!chidetoggle);
  }

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;

    // Update the value
    setData((prev) => ({ ...prev, [name]: value }));

    if (name === 'fullName') {
      const nameError = validateName(value);
      setData((prev) => ({ ...prev, fullNameError: nameError }));
    }
  }

  const validateForm = () => {
    let isValid = true;

    const updatedData = { ...data };

    const nameError = validateName(data.fullName);
    if (nameError) {
      updatedData.fullNameError = nameError;
      isValid = false;
    } else {
      const fullNameTrimmed = data.fullName?.trim() || "";
      if (!fullNameTrimmed || !validNameRegex.test(fullNameTrimmed)) {
        updatedData.fullNameError = 'Please enter your full name.';
        isValid = false;
      } else {
        updatedData.fullNameError = '';
      }
    }

    if (!data.email || !validEmailRegex.test(data.email)) {
      updatedData.emailError = 'Please enter a valid email address.';
      isValid = false;
    } else {
      updatedData.emailError = '';
    }

    if (!data.password) {
      updatedData.passwordError = 'Please create a password.';
      isValid = false;
    } else if (data.password.length < 8) {
      updatedData.passwordError = 'Your password needs to be at least 8 characters long.';
      isValid = false;
    } else {
      updatedData.passwordError = '';
    }

    if (!data.confirmPassword) {
      updatedData.confirmPasswordError = 'Passwords must match. Please try again.';
      isValid = false;
    } else if (data.confirmPassword !== data.password) {
      updatedData.confirmPasswordError = 'Passwords must match. Please try again.';
      isValid = false;
    } else {
      updatedData.confirmPasswordError = '';
    }

    setData(updatedData);

    return isValid;
  };


  // console.log(data)

  const signup = async (e) => {
    e.preventDefault();
    if (validateForm()) {

      setIsSigningIn(true);

      const fullName = data?.fullName?.trim() || '';
      const [firstNameRaw, ...lastNameParts] = fullName.split(' ');
      const lowerEmail = data.email?.trim().toLowerCase() || "";
      
      const capitalizeWords = (str) => { return str ? str.replace(/\b\w/g, char => char.toUpperCase()) : '';};
      const firstName = capitalizeWords(firstNameRaw || '');
      const lastName = capitalizeWords(lastNameParts.join(' ') || '');
      const capitalizedFullName = capitalizeWords(fullName);

      fetch(`${process.env.REACT_APP_API_URI}/v4/organisation/signup`, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json',
            "Origin": "https://d1xqw9fxllglrv.cloudfront.net"
         },
        body: JSON.stringify({
          email: lowerEmail,
          password: data.password,
          confirmPassword: data.confirmPassword,
          assessmentId: process.env.REACT_APP_CLIENT_ID,
          fullName: capitalizedFullName,
          firstName: firstName,
          lastName: lastName,
        })
      })
        .then(response => response.json())
        .then(res => {
          // console.log(res);
          if (res.status == 'success') {

            const tokenExpiration = new Date(new Date().getTime() + 3600 * 1000).toISOString();
            authCtx.login(res.token, res.userId, res.orgId, data?.fullName, data.email, "organisation", tokenExpiration);
            console.log("signup payload",res.token, res.userId, res.orgId,  data.email /* username */ , data.email, "organisation", tokenExpiration)
            navigate(`/signup-details/${res.orgId}`);
            setIsSigningIn(false);

          } else {
            setData((prev) => ({ ...prev, emailError: 'User already exists!' }));
            setIsSigningIn(false)
          }
        })
        .catch((err) => {
          console.error("Failed to signup, please try again", err);
        });
    }
  };

  const register = (e) => {
    e.preventDefault();
    navigate('/signup-details')
  }

  const handleNameChange = (event) => {
    const { name, value } = event.target;
    setFullName(name);
    localStorage.setItem("fullName", name);
    switch (name) {
      case 'fullName':
        setData(prev => ({ ...prev, [`${name}Error`]: !validNameRegex.test(value) ? ' Please enter your full name' : '' }));
        break;
      default:
        break;
    }
  };


  console.log("data.fullName", data.fullName)


  return (
    <div className="container signup-container">
      <div className="inner-container">
      <div className="left">
        <img src={NewTPLogo} alt="Logo" style={{ width: "113", height: "129" , objectFit: "contain"}} />
        <h1>Welcome to the <br /> Quadrant Flow Portal  </h1>
          </div>
        <div className="right">
          <form className="form" onSubmit={(e) => signup(e)}>
            <h2>Create your account</h2>
            {/* <h4>Login</h4> */}
            <Stepper steps={{ current: 1, total: 3 }} />
            <div className="input-box">
              <label htmlFor="name">
                Full Name<span className="asterisk-mark">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                id="fullName"
                placeholder="e.g. Simon Peter"
                value={data.fullName}
                onChange={handleChange}
              />
              {data?.fullNameError?.length > 0 && (
                <p className="error-message">{data.fullNameError}</p>
              )}
            </div>

            <div className="input-box">
              <label htmlFor="email">
                Email<span className="asterisk-mark">*</span>
              </label>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="e.g. simonpeter@petra.org"
                value={data.email}
                onChange={handleChange}
              />
              {data?.emailError?.length > 0 && (
                <p className="error-message">{data.emailError}</p>
              )}
            </div>

            <div className="input-box">
              <label htmlFor="password">
                Create Password<span className="asterisk-mark">*</span>
              </label>
              <div className="input-wrapper">
                <input
                  type={hidetoggle ? "password" : "text"}
                  name="password"
                  id="create-password"
                  value={data.password}
                  onChange={handleChange}
                  placeholder="Type a new password"
                />
                <img
                  src={hidetoggle ? hideicon : showicon}
                  alt={hidetoggle ? "Hide password" : "Show password"}
                  onClick={passwordShow}
                  className="toggle-icon"
                  role="button"
                  aria-label="Toggle password visibility"
                />
              </div>
              {data?.passwordError?.length > 0 && (
                <p className="error-message">{data.passwordError}</p>
              )}
            </div>

            <div className="input-box" style={{ marginBottom: data.confirmPasswordError ? "30px" : '55px' }}>
              <label htmlFor="confirmPassword">
                Confirm Password<span className="asterisk-mark">*</span>
              </label>
              <div className="input-wrapper">
                <input
                  type={chidetoggle ? "password" : "text"}
                  name="confirmPassword"
                  id="confirmPassword"
                  value={data.confirmPassword}
                  onChange={handleChange}
                  placeholder="Retype password"
                />
                <img
                  src={chidetoggle ? hideicon : showicon}
                  alt={chidetoggle ? "Hide password" : "Show password"}
                  onClick={confpasswordShow}
                  className="toggle-icon"
                  role="button"
                  aria-label="Toggle password visibility"
                />
              </div>
              {data?.confirmPasswordError?.length > 0 && (
                <p className="error-message">{data.confirmPasswordError}</p>
              )}
            </div>

            <button disabled={isSigningIn} type="submit" onClick={signup}>
              {isSigningIn ? (
                <CircularProgress size={20} style={{ color: "#fff" }} />
              ) : (
                "Create Your Login"
              )}
            </button>

            <div className="form-footer">
              <p>
                Already have an account?{" "}
                <Link to="/login">
                  <span>Log in here</span>
                </Link>
              </p>
            </div>
          </form>


        </div>
      </div>
      {/* <div className="signup-form">
        <h1>SignUp</h1>
        <form>
          <div className={`input-box ${data.emailError ? 'error' : ''}`}>
            <label htmlFor="email">Email*</label>
            <input
              type="email"
              value={data.email}
              name='email'
              onChange={(e) => handleChange(e)}
              // placeholder='example@gmail.com' 
            />
            {data.emailError.length > 0 ? <div className='form-error'>{data.emailError}</div> : null}
          </div>

          <div className={`input-box ${data.passwordError ? 'error' : ''}`}>
            <label htmlFor="password">Password*</label>
            <input
              type={hidetoggle ? "password" : "text"}
              name="password"
              id="password"
              value={data.password}
              onChange={(e) => handleChange(e)}
            />
            <img src={hidetoggle ? hideicon : showicon} alt="hideicon" onClick={passwordShow} className="hideicon" />
            {data.passwordError.length > 0 ? <div className='form-error'>{data.passwordError}</div> : null}
          </div>

          <div className={`input-box ${data.confirmPasswordError ? 'error' : ''}`}>
            <label htmlFor="confirmPassword">Confirm Password*</label>
            <input
              type={chidetoggle ? "password" : "text"}
              name="confirmPassword"
              id="confirmPassword"
              value={data.confirmPassword}
              onChange={(e) => handleChange(e)}
            />
            <img src={chidetoggle ? hideicon : showicon} alt="hideicon" onClick={confpasswordShow} className="hideicon" />
            {data.confirmPasswordError.length > 0 ? <div className='form-error'>{data.confirmPasswordError}</div> : null}
          </div>
          <button onClick={(e) => signup(e)} disabled={!validateForm()} className={`login-button ${!validateForm() ? 'disabled' : ''}`}>
            {
              isSigningIn ? <CircularProgress size={20} style={{ color: "#fff" }} /> : "Create an account"
            }
          </button>
          <div className="form-footer">Already have an account? <a href="/login">Log In</a></div>
        </form>
      </div>
      <Slider {...settings} style={{ width: "50%", maxWidth: '428px' }}>
        <div>
          <div className="signup-testimonial">
            <div className="avatar-img">
              <img src={person1} alt="" />
            </div>
            <div className="stars-container">
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
            </div>
            <div className="testimonial">"Cultivating a vocationally informed church requires knowing and understanding your congregation thoroughly. With Scatter, our leadership team could gather this information swiftly and, more importantly, in an organized manner. This helped us plan and implement new priorities and practices that minister to and engage our congregants' daily lives. "</div>
            <div className="testimonial-details">
              <div className="name">TIM PARKER | <span className="designation">ROCK CHURCH, LEAD PASTOR</span></div>
            </div>
          </div>
        </div>
        <div>
          <div className="signup-testimonial">
            <div className="avatar-img">
              <img src={person2} alt="" />
            </div>
            <div className="stars-container">
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
            </div>
            <div className="testimonial">"Breaking away from generational patterns to cultivate and nourish a church that is flourishing at work, outside our church engagements, is no tiny task. With a reasonably large congregation, it seemed only more impossible to tend to all. Scatter made it so quick to understand the composition of our congregation. We were able to dig out key insights to achieve our end."</div>
            <div className="testimonial-details">
              <div className="name">DAVE SMITH | <span className="designation">LIGHT CHURCH, LEAD PASTOR</span></div>
            </div>
          </div>
        </div>
        <div>
          <div className="signup-testimonial">
            <div className="avatar-img">
              <img src={person3} alt="" />
            </div>
            <div className="stars-container">
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
            </div>
            <div className="testimonial">"Our leadership team can view just 1 dashboard and make decisions to better curate opportunities to nurture our congregation according to its specific needs and talents."</div>
            <div className="testimonial-details">
              <div className="name">MATT ROSE | <span className="designation">FAITH FELLOWSHIP, LEAD PASTOR</span></div>
            </div>
          </div>
        </div>
      </Slider> */}

    </div>
  )
}

export default Signup;
